export default __webpack_public_path__ + "static/media/todo.47741742.png";